module.exports = __webpack_public_path__ + "img/weixinpaywarning.8468c6e1.png";